import React from "react";

const BreadcrumbSeparator = props => {
  return(
    <span style={{padding:"0px 7px"}}>
      /
    </span>
  )
};

export default BreadcrumbSeparator;
